import React from "react";
import UploadHeader from "../components/common/UploadHeader";
import ProfileUpdateForm from "../components/profileUpdate";

const ProductUpdate = () => {
  return (
    <>
      <UploadHeader />
      <ProfileUpdateForm />
    </>
  );
};

export default ProductUpdate;
